import { useCallback, useEffect } from 'react'
import { currentWorkstationPageContext } from '@/frontend/features/AgentChats/workstationPageContext'

const eventName = 'stationzero:open-dashboard-chat'
const clearFocusEvent = 'stationzero:clear-dashboard-focus'
export function openDashboardChat() { window.dispatchEvent(new Event(eventName)) }
/** The chart the chat is about stops being the focus (the reader dismissed it in the chat). */
export function clearDashboardFocus() { window.dispatchEvent(new Event(clearFocusEvent)) }
export function onClearDashboardFocus(handler: () => void) {
  window.addEventListener(clearFocusEvent, handler)
  return () => window.removeEventListener(clearFocusEvent, handler)
}

export function useDashboardWidgetBridge(setOpen: (value: boolean) => void, setHasOpened: (value: boolean) => void) {
  useEffect(() => {
    const open = () => { setHasOpened(true); setOpen(true) }
    window.addEventListener(eventName, open)
    return () => window.removeEventListener(eventName, open)
  }, [setOpen, setHasOpened])
  return () => {
    const context = currentWorkstationPageContext()
    // Existing widget behavior elsewhere is unchanged.
    return context.surface === 'dashboard_runtime' ? context : {}
  }
}

// A new conversation started from a dashboard belongs to the publication's
// project when the selected worker is one of its agents. Only then the agent
// receives the signed project context it needs to check the chart's data.
export function dashboardSessionScope(workerId: string | null | undefined) {
  if (!workerId) return null
  const context = currentWorkstationPageContext()
  if (context.surface !== 'dashboard_runtime') return null
  const project = context.project as { id?: unknown; chat_worker_ids?: unknown } | undefined
  if (typeof project?.id !== 'string' || !Array.isArray(project.chat_worker_ids)) return null
  if (!project.chat_worker_ids.includes(workerId)) return null
  return { source: 'fde_project', fdeProjectId: project.id }
}

export function useDashboardSessionScope(workerId: string | null | undefined) {
  return useCallback(() => dashboardSessionScope(workerId), [workerId])
}
